import englishMessages from 'ra-language-english';

export default {
    ...englishMessages,
    pos: {
        search: 'Search',
        configuration: 'Configuration',
        language: 'Language',
        theme: {
            name: 'Theme',
            light: 'Light',
            dark: 'Dark',
        },
        auth: {
            username: 'Username',
            password: 'Enter your password',
            errorlongcharacter: 'Your password must be at least 6 characters long',
            errorspecial: 'Password must contains a minimum of 1 lower case letter [a-z] and a minimum of 1 upper case letter [A-Z] and a minimum of 1 numeric character [0-9] and a minimum of 1 special character.',
            errorsame: 'The password is not the same',
            Confirmpassword: 'Repeat your new password',
            email: 'Enter your email address',
            signIn: 'Sign in',
            emailIncorrect: 'The email address is incorrect',
            errorEmail: 'You have entered a wrong email-address',
            doesNotExist: 'Email or username does not exist',
            forgot: 'FORGOT YOUR USERNAME OR PASSWORD',
            forgotTitle: 'Forgot your password',
            title: 'We’ll help you reset it and get back on track.',
            reset: 'Reset password',
            back: 'BACK',
            stringLengthMax: 'Maximum of 50 characters are allowed',
            sendMailError: 'Request error,Please try again',
            errorLogin: 'You have entered either wrong username or password, please try again!',
            Titleforceuser: 'Choose a new password',
            forcetitle: 'To make it easier for you to remember the password,',
            titleforce: 'we ask you to choose your own',
            newpassword: 'Enter your new password',
            repeatnewpasssword: 'Repeat your new password',
            submitpassword: 'ready, choose my new password',
            checkrepeatpassword: 'The new password is not the same',
            confirmEmail: "Please confirm your email",
            confirmEmailConstent: 'We have sent you new password on your email',
            backtologin: 'Back to login ',
            enterEmail: 'Enter your email address',
            resetSuccess: "Reset password success",
            NotFound: 'Not Found',
            ConstentNotFound: 'Either you typed a wrong URL, or you followed a bad link..',
            GoHome: 'Go Home',
            enterEmailResetPassword: 'Please enter the email for reset your password.',
        },
        user: {
            name: 'Users',
            search: 'Search user',
            go: "Go to users",
            back: 'Back to users',
            title: 'Region Stockholm',
            create: 'Create new user',
            star: '*',
            required: 'Required',
            levelsreach: 'Search level',
            searchcluster: 'Search cluster',
            expandlevel: 'EXPAND LEVELS',
            role: 'Role',
            language: 'Language',
            level: 'Level',
            updatepassword: 'update password',
            changepassword: 'Change password',
            setuserinactive: 'SET USER INACTIVE',
            cluster: 'Cluster',
            clusters: 'Clusters',
            save: 'SAVE',
            username: 'Username',
            password: 'Password',
            forceuser: 'Force user to change password',
            firstname: 'First Name',
            lastname: 'Last Name',
            userRole: 'Role',
            email: 'Email',
            phonenumber: 'Phone number',
            company: 'Organisation/Company',
            changelevel: 'Change Level',
            changeimage: 'Change profile image',
            uploadphoto: 'UPDATE PHOTO',
            helperText: 'Set firstname is already taken, try with another!',
            content: 'This is the first name',
            close: 'Close',
            deleteuser: 'DELETE USER',
            cancel: 'Cancel',
            ok: 'Ok',
            deleteuseredit: 'DELETE USER',
            contentDelete: ' Are you sure you want to continue?',
            edit: 'Editing ',
            edituser: 'edit',
            TitleUsesName: 'User Name',
            ConstentUserName: 'This is user name',
            TitlePassword: 'Password',
            ConstentPassword: 'This is Password',
            TitleFirstName: 'First Name',
            ConstentFirstName: 'This is First Name',
            TitleLastName: 'Last Name',
            ConstentLastName: 'This is Last Name',
            TitleEmail: 'Email',
            ConstentEmail: 'This is Email',
            TitlePhoneNumber: 'Phone Number',
            ConstentPhoneNumber: 'This is Phone Number',
            TitleCompany: 'Company',
            ConstentCompany: 'This is Company',
            changePassword: 'Change Password',
            CreateNewPassword: '  CREATE NEW PASSWORD',
            TitelSendMail: 'Please confirm your email',
            ConstentSendMail: 'We have sent you new password on your email.',
            updatefor: 'Update password for:',
            sendpassword: 'SEND NEW PASSWORD',
            success: 'change password success',
            editUser: 'Great job! $1 saved!',
            createUser: 'Great job! $1 create success!',
            deleted: 'Great job! $1 deleted!',
            deleteUser: 'User deleted',
            error: {
                username: 'Set username is already taken, try with another!',
                email: 'Set email is already taken, try with another!',
                password: 'Password must contains a minimum of 1 lower case letter [a-z] and a minimum of 1 upper case letter [A-Z] and a minimum of 1 numeric character [0-9] and a minimum of 1 special character.',
                notexist: 'User not exist',
                exist: 'User already exist',
                special: `User name not exist special characters {|}~!"#$%&'()*+,-./:;<=>?@[]^_`,
                datanotfound: "No users match your search criteria!",
                usernamecharacter: 'Input user name < 50 characters',
                failed: 'Change password failed',
                invalid: 'The old password you have entered is incorrect',
            },
            mobileAppUser: 'MOBILE APP USER',
            enableVideoCall: 'ENABLE VIDEO CALL'
        },
        dashboard: {
            goToInfoPage: 'Go to assigned info page',
            importCSV: 'Import CSV',
            cluster: 'Cluster',
            group: 'Group',
            entity: 'Entity',
            notfound: 'No data found',
            notFoundDevicesAssign: 'No device assign',
            monthly_revenue: 'Monthly Revenue',
            new_orders: 'New Orders',
            pending_reviews: 'Pending Reviews',
            new_customers: 'New Customers',
            pending_orders: 'Pending Orders',
            constent: 'This is the name of the cluster, inside it also has the floor, room and device of the home',
            order: {
                items:
                    'by %{customer_name}, one item |||| by %{customer_name}, %{nb_items} items',
            },
            welcome: {
                title: 'Welcome to react-admin demo',
                subtitle:
                    "This is the admin of an imaginary poster shop. Feel free to explore and modify the data - it's local to your computer, and will reset each time you reload.",
                aor_button: 'react-admin site',
                demo_button: 'Source for this demo',
            },
            title: 'Region Stockholm',
            searchEntity: 'Search entity',
            search: 'Search cluster',
            entitys: 'Entities',
            groups: 'Groups',
            clusters: 'Clusters',
            rooms: 'Rooms',
            devices: 'Devices',
            entity: 'Entity',
            group: 'Group',
            cluster: 'Cluster',
            room: 'ROOM',
            device: 'Device',
            tv: 'TV',
            vod: 'VOD',
            offline: 'Offline',
            menu: 'Menu',
            createFailed: 'Create failed',
            infoChannel: 'Info channel',
            usageData: 'Usage data',
            clusterAndDevice: 'Cluster and devices',
            require: 'Incorrect entry.',
            close: 'Close',
            addCluster: 'Add new cluster',
            cancel: 'Cancel',
            CANCEL: 'CANCEL',
            create: 'Create',
            name: 'Name',
            inheritFrom: 'Inherit from',
            selectOrCreateEntity: 'Select or create new entity',
            selectOrCreateGroup: 'Select or create new group',
            selectInfoPage: 'Select info page',
            createNew: 'CREATE NEW',
            nameAreNew: 'Name a new',
            roomLocation: 'Room location',
            entityGroup: 'Entity - Group'
        },
        menu: {
            sales: 'Sales',
            catalog: 'Catalog',
            customers: 'Customers',
            users: 'User Management',
            roles: 'Roles',
            adminUsers: 'Admin Users',
            node: 'Node managament',
            clusterAndService: 'Clusters & Services',
            general: 'General (Cluster Info)',
            mailBox: 'Message Inbox',
            usageData: 'Usage data',
            alarm: 'Alarm Inbox',
            commerce: 'Commerce',
            payment: 'Payment',
            systemData: 'System data',
            contentManagement: 'Content Management',
            channelManagement: 'Channels',
            infoChannelManagement: 'Info Channels',
            infoPage: 'Info Pages',
            templates: 'Tempalates (Look & Feel)',
            fileManager: 'File Manager',
            alarmTone: 'Alarm Tone',
            systemSetup: 'System Setup',
            userAdministration: 'Users',
            serverStatus: 'Server Status',
            serverLog: 'Server Log',
            hardwareSetup: 'Hardware Setup',
            deviceProfile: 'Device Profiles',
            clientDevice: 'Client Devices',
            remoteTv: 'TV & Remote control',
            maintenance: 'Maintenance',
            messageTemplates: 'Message Templates',
            calendar: 'Calendar',
            emailTest: 'Email/Alarm Testing',
            customShortcus: 'Custom shortcuts',
            Movies: 'Movies',
            channelGroup: 'Channel group',
            channelCategory: 'Channel category',
            channelProgram: 'Channel & program',
            calendarType: 'Calendar Type'
        },
        appbar: {
            version: 'Version',
            message: 'Messages',
            support: 'Support',
            logout: 'Logout'
        },
        support: {
            menu: 'Setup Supporter',
            title: 'Report issue',
            issue: 'Issue',
            description: 'Description',
            contactInfo: 'Contact info',
            phoneNumber: 'Enter your phone number',
            success: 'Your issue has been successfully sent.',
            unAssign: 'Un-assigned users',
            assignUnAssign: 'Assign/Unassign',
            id: 'ID',
            userName: 'UserName',
            email: 'Add email',
            eventType: 'Add Type',
            addAttachments: 'Add attachments',
            subjectContent: 'This is issue subject'
        },
        devices: {
            name: 'Devices',
            create: 'Create new device',
            search: 'Search device',
            createProfile: 'Create new device profile',
            title: 'Device Profiles',
            titleDevices: 'Devices',
            popperTitle: 'Device profile name',
            popperContent: 'This is device profile name',
            description: 'This is description for device profile',
            nativeAppPopperTitle: 'Native App',
            nativeAppPopperContent: 'This is native app name/id',
            remoteControlType: 'Remote Control Type',
            remoteControlTypePlaceholder: 'Filter remote control type',
            SnackbarAssign: 'Assign device success',
            table_field: {
                name: 'Name',
                description: 'Description',
                device_authentication: 'Device Authentication',
                remote_control_type: 'Remote Control Type',
                native_app: 'Native App',
                app_name: 'App name',
                app_id: 'App id',
                addNativeApp: 'Add native app',
            },
            errors: {
                existed_name: 'This name is already existed'
            },
            back: 'Back to device profiles',
            add: 'Add device profile',
            ipAddress: 'IP Address',
            platform: 'Platform',
            profile: 'Profile',
            model: 'Model',
            macAddress: 'MAC Address',
            serialNumber: 'Serial Number',
            firmware: "Firmware version",
            status: 'Status',
            onlineRate: 'Online Rate',
            displayMode: 'Display Mode',
            backDevice: " Back to devices",
            addDevice: 'Add device',
            searchProfile: 'Search device profile',
            searchPlatform: 'Search platform',
            Parental: "Parental control age",
            contentParental: 'Content rated for this age or lower will be viewable on the device. -1 for allowing full access',
            Alias: 'Alias',
            contentAlias: 'An alias for the device; a free-form name that can be set by clients and/or staff for device identification',
            macAddressSecondary: 'MAC address secondary',
            contentMacAddressSecondary: 'This is MAC address secondary',
            contentSerialNumber: 'This is serial number',
            contentMacAddress: 'This is MAC address',
            contentIPAddress: 'This is IP address',
            resolution: 'Resolution',
            searchResolution: 'Search resolution',
            name: 'Name',
            contentName: 'This is name device',
            assignToRoom: 'Assign to room',
            searchDisplayMode: 'Search Display Mode',
            assign: 'Assign',
            count: 'Count',
            rooms: 'Rooms',
            search_rooms: 'Search rooms',
            noRoomAvailable: 'No room available',
            noFirmwareAvailable: 'No firmware available',
            firmwareUpdate: 'Firmware update',
            noData: 'No devices match your search criteria!',
            reboot: 'Reboot',
            turnOff: 'Turn off',
            notification: 'Send notification',
            assignToRoom: 'Assign to room',
            contentModel: 'This is model',
            room: 'Room',
            search_firmware: 'Search firmware',
            version: 'Version',
            activate: 'Activate',
            createNewDeviceFirmware: 'Create new device firmware',
            devicePlatform: 'Device platform',
            deviceFirmware: 'Device firmware',
            deviceModel: 'Device Model',
            unassginFromRoom: 'Unassgin from room',
            roomName: 'Room Name',
            roomID: 'Room ID',
            roomCluser: 'Cluster'
        },
        relatives: {
            createRelative: {
                name: 'New folder',
                placeholder: 'Enter folder name',
                success: 'Great job! $1 created!'
            },
            editRelative: {
                name: 'New folder',
                placeholder: 'Enter folder name',
                success: 'Great job! $1 saved!'
            },
            deleteRelative: {
                name: 'New folder',
                placeholder: 'Enter folder name',
                success: 'Great job! $1 deleted!'
            },
            unAssignRelative: {
                name: 'New folder',
                placeholder: 'Enter folder name',
                success: 'Great job! $1 unassigned!'
            },
        },
        categories: {
            url: 'URL',
            pixel: 'PIXEL DIMENSIONS',
            filesize: 'FILE SIZE',
            DropFile: 'Drop files',
            FileExist: 'Filename already exist',
            OverrideFile: 'Override file',
            chooseFolder: 'Or choose folder',
            filesSelected: 'files selected',
            fileSelected: 'file selected',
            Download: 'Download',
            Move: 'Move',
            Copy: 'Copy',
            Rename: 'Rename',
            Delete: 'Delete',
            createBtn: 'Create new folder',
            uploadBtn: 'Upload file',
            delete_folder: 'Delete folder',
            createFolder: {
                name: 'New folder',
                placeholder: 'Enter folder name',
                success: 'Great job! $1 created!'
            },
            editFolder: {
                name: 'New folder',
                placeholder: 'Enter folder name',
                success: 'Great job! $1 saved!'
            },
            deleteFolder: {
                name: 'New folder',
                placeholder: 'Enter folder name',
                success: 'Great job! $1 deleted!'
            },
            uploadFiles: {
                upload: 'Upload',
                success: 'Great job! Upload success!'
            },
            warningTitleDelete: 'Delete category/file',
            warningContentDelete: 'Are you sure you want to delete this category/file?',
            existed: 'Name existed',
            nodata: 'This folder is empty',
            searchnodata: 'No data found',
            uploaded: 'UPLOADED',
            uploadedBy: 'UPLOADED BY',
            enterName: 'Enter name',
            categoryChannel: 'Category channel',
            deleteCategoryChannel: 'Delete category channel',
            errorFileName: `A file name can't contain any of the following characters: \\/:*?”<>| `,
            folderNameTitle: 'Folder Name',
            folderName: 'This is folder name',
            deleted: 'Folder/file deleted!',
            onlyOne: 'Please select only 1 file',
            copied: '1 file copied',
            moved: '1 file moved',
            copies: ' files copied',
            moves: ' files moved',
            actionSuccess: 'Great job! $1 to folder $NAME!',
            edit: 'Edit category',
            category: 'Category',
            access: 'You do not have access to the File Manager. Please contact the administrator for more support'
        },
        channels: {
            noData: 'No channels match your search criteria!',
            addChannel: 'Add channel',
            addNewChannel: 'Add new channel',
            back: 'Back to channels',
            backToChannelList: 'Back to Channel list',
            editting: 'Editing ',
            channelNameTitle: 'Channel name',
            channelName: 'This is channel name',
            internalNameTitle: 'Internal name',
            internalName: 'This is internal name',
            channelNumberTitle: 'Channel number',
            channelNumber: 'This is number of channel',
            epgTitle: 'Epg',
            epg: 'This is Electronic Program Guide',
            radio: 'Radio',
            media: 'Media',
            mediaFile: 'Media file',
            categories: 'Categories',
            more: '... More',
            chooseLogo: 'Choose logo',
            browse: 'Browse',
            change: 'Change',
            list: 'Channel list',
            deletes: 'Delete channels',
            delete: 'Delete channel',
            search: 'Search channels',
            confirmDelete: 'Do you want to delete the selected channels?',
            createGroup: 'Create group',
            editGroup: 'Edit group',
            groupNameTitle: 'Group name',
            groupName: 'This is group name',
            externalCodeTitle: 'External code',
            externalCode: 'This is external code',
            name: 'Channels',
            groupChannel: 'Group channel',
            createNewGroup: 'Create new group',
            deleteGroupChannel: 'Delete group channel',
            editSchedule: 'Edit schedule',
            intervalsOf: 'Intervals of',
            intervalOf: 'Interval of:',
            minutes: ' minutes',
            sec: 'sec',
            default: '12sec (default)',
            fromFile: 'From file',
            radioChannel: 'Radio channel',
            searchRadioChannel: 'Search radio channel',
            addSound: 'Add sound',
            addSchedule: 'Add schedule',
            useIn: 'Use in',
            import: 'Import channel',
            noChannelsSelected: 'No channels selected',
            importFromFileType: 'Import from:',
            importFromCSVFile: 'CSV file',
            importFromRawChannelFile: 'RAW channel file'
        },
        messages: {
            warningTitleDelete: 'Delete message',
            warningContentDelete: 'Are you sure you want to delete this message?',
            attachBtn: 'Add image',
            dyslexieFont: 'Dyslexie Font',
            dyslexie: 'Dyslexie',
            cancel: 'Cancel',
            save: 'SAVE DRAFT',
            send: 'SEND MESSAGE',
            subject: 'Subject',
            message: 'Message',
            day: 'Day',
            time: 'Time',
            constentDay: 'This is the order of date to send message (0, 1, 2...)',
            constentTime: 'This is the time to send message',
            constentSubject: 'This is message subject',
            type: 'Type',
            reminder: 'Reminder',
            warningtype: 'Warning',
            informationtype: 'Information',
            eventtype: 'Event',
            reminderNone: "None",
            reminderOnTime: "At time of event",
            reminder5MinBefore: "5 minutes before",
            reminder10MinBefore: "10 minutes before",
            reminder15MinBefore: "15 minutes before",
            reminder20MinBefore: "20 minutes before",
            reminder25MinBefore: "25 minutes before",
            reminder30MinBefore: "30 minutes before",
            constentType: 'This is message type',
            schedule: 'Schedule',
            scheduler: 'Scheduler',
            constentSchedule: 'This is message schedule',
            calendar: 'Calendar',
            constentCalendar: 'This is calendar picker',
            expiration: 'Expiration',
            constentExpiration: 'This is message expiration',
            expireDateTimeText: "Date and time for message expire",
            constent: 'Content',
            constentContent: 'This is message content',
            placeholder: "Type your message",
            template: "Template",
            templates: "Templates",
            required: "Required",
            editMessage: "Edit message",
            nameTemplate: "This is template name",
            nameSchedule: "This is Schedule template name",
            recurrence: "Recurrence",
            isDate: 'Day 0 is already exist',
            yes: "Yes",
            no: "No",
            messageDetail: 'Message Detail',
            scheduleType: 'Schedule type',
            reply: 'Reply',
            errorExpiration: 'Invalid expiration time',
            minutes: 'minutes ago',
            justNow: 'Just now',
            minute: 'minute ago',
            hours: 'hours ago',
            hour: 'hour ago',
            January: 'January',
            February: 'February',
            March: 'March',
            April: 'April',
            May: 'May',
            June: 'June',
            July: 'July',
            August: 'August',
            September: 'September',
            October: 'October',
            November: 'November',
            December: 'December'


        },
        alarm: {
            send: 'SEND ALARM',
            createCalendar: 'CREATE CALENDAR',
            constentSubject: 'This is alarm subject',
            alarmTone: "Alarm tone",
            constentSchedule: 'This is alarm schedule',
            constentExpiration: 'This is alarm expiration',
            expireDateTimeText: "Date and time for alarm expire",
            constentContent: 'This is alarm\'s message content',
            alarmDetail: 'Alarm Detail',
            back: 'Back',
            delete: 'Delete'
        },
        usageData: {
            emptyCluster: 'Cluster cannot empty',
            emptySection: 'Section cannot empty',
            export: 'EXPORT',
            serverUptime: 'Server uptime',
            serverDowntime: 'Server downtime',
            selectCluster: 'Select clusters',
            languageSelection: 'Language Selection',
            noData: 'No data',
            timeChannel: 'Time Channel',
            messageAlarm: 'Messages/Alarms',
            nodeSelection: 'Info Page - Node Selection',
            selectInfoPage: 'Select infopages',
            sessionReport: 'Session Report',
            configuration: 'Configuration'
        },
        deviceFirmware: {
            delete: 'Delete Device Firmware',
            firmware: 'Firmware',
            back: 'Back to device firmware',
            edit: 'Editing device firmware',
            add: 'Add device firmware'
        },
        remoteControl: {
            delete: 'Delete Remote Control',
            confirmDelete: 'Do you want to delete the selected remote controls?',
            add: 'Add a new remote',
            search: 'Search remote',
            title: 'Remote',
            mapping: 'Mapping',
            keys: 'Keys',
            name: 'Remote control name',
            name_content: 'This is remote control name',
            description: 'This is short description of remote control',
            keyName: 'Name:',
            keyText: 'Text:',
            keyCode: 'Code:',
            addKey: 'Add key',
            selectAll: 'Select All',
            clearAll: 'Clear All',
            addCustomKey: 'Add custom key',
            back: 'Back to remotes',
            button: 'Button',
            editing: 'Editing',
            addRemote: 'Add remote'
        },
        movie: {
            delete: 'Delete Movie',
            confirmDelete: 'Do you want to delete the selected movie(s)?'
        },
        common: {
            video: 'Video',
            icon: 'Icon',
            required: 'Required',
            okay: 'Okay',
            cancel: 'Cancel',
            create: 'Create',
            close: 'Close',
            delete: 'Delete',
            deleted: 'Deleted',
            edit: 'Edit',
            save: 'Save',
            copy: 'Copy',
            rename: 'Rename',
            publish: 'Publish',
            cancelEdit: 'Cancel Edit',
            noRecordsFound: 'No Records found',
            scheduleExpired: 'Schedule is expired',
            confirm: 'Confirm',
            filter: 'Filter',
            undo: 'Undo',
            online: 'Online',
            offline: 'Offline',
            mb: 'mb',
            kb: 'kb',
            error: 'Error',
            choose: 'Choose',
            paste: 'Paste',
            move: 'Move',
            size: 'Size',
            overlay: 'Overlay',
            rotate: 'Rotate',
            browse: 'Browse',
            change: 'Change',
            submit: 'Submit',
            noData: 'No data',
            add: 'Add',
            language: 'Language',
            icon_size: {
                small: 'Small',
                medium: 'Medium',
                large: 'Large'
            },
            saved: 'Saved',
            createInfoPage: 'Info Page create success',
            renameInfoPage: 'Info Page rename success',
            cloneInfoPage: 'Info Page clone success',
            previewInfoPage: 'Previewing info page',
            mainInfoPage: 'Main',
            backgroundImage: 'Background image',
            pinLock: 'Pin lock',
            editor: 'New page editor',
            infoMessage: 'INFO MESSAGE',
            media: 'Media',
            start: 'Start',
            stop: 'Stop',
            sound: 'Sound',
            contentSound: 'This is Sound',
            standByControl: 'Standby control',
            contentStandByControl: 'This is standby control',
            contentOverlap: 'Schedules timeline cannot be overlapped. Please update the timeline for each schedule properly.',
            function: 'Function',
            contentFunction: 'This is function',
            nodeType: 'Node Type',
            contentNodeType: 'This is node type',
            name: 'Name',
            contentName: 'This is name',
            childLock: 'Child Lock',
            contentChildLock: 'This is child lock',
            usb: 'USB',
            contentUSB: 'This is usb',
            title: 'Title',
            contentTitle: 'This is title',
            url: 'URL',
            contentURL: 'This is URL',
            navigationKey: 'Navigation key',
            navigationKeys: 'Navigation keys',
            contentNavigationKey: 'This is navigation key ( Ex: KEY_DOWN : move down, KEY_UP : move up, KEY_BACK : back... )',
            rss: 'RSS',
            contentRss: 'This is RSS',
            updateFrequency: 'Update frequency',
            type: 'Type',
            update: 'Update',
            errorExpiration: 'Invalid expiration time',
            loading: 'Loading...',
            none: 'None'
        },
        media: {
            createCategory: 'Create category',
            categoryName: 'Category name',
            cancel: 'Cancel',
            save: 'Save',
            categoryMedia: 'Category Media',
            createNewCategory: 'Create new category',
            Name: 'Name',
            Edit: 'Edit',
            deleteMedia: 'Delete category media',
            back: 'Back to media',
            delete: 'Delete media',
            chooseImage: 'Choose image',
            chooseIcon: 'Choose icon',
            descriptionContent: 'This is short description of media',
            descriptionCategoryMedia: 'This is short description of media',
            fileType: 'File Type',
            addFile: 'Add file',
            file: 'File',
            uri: 'URI',
            movie: 'Movie',
            searchMovie: 'Search movie',
            addMovie: 'Add a new movie'
        },
        infochannel: {
            warningMsg: 'The current version only supports these media format : mp4, mp3, jpg, jpeg, png and powerpoint (ppt, pptx). Other formats may not work properly.',
            back: 'Back to Channel list',
            title: 'Create new info channel',
            name: 'Channel name',
            id: 'Id',
            TitleChannelName: 'Channel Name',
            ConstentChannelName: 'This is channel name',
            inheritFrom: 'Inherit from',
            createInheritFrom: 'Create schedule',
            save: 'SAVE',
            editChannel: 'Edit Channel',
            date: 'Date',
            start: 'Start',
            stop: 'Stop',
            Imageshowtime: 'Image show time',
            Sound: 'Sound',
            Standbycontrol: 'Standby control',
            force: 'Force to show info channel',
            standby: 'Standby after info channel',
            addText: 'Add Text',
            remove: 'Remove',
            removeAll: 'Remove All',
            fontSize: 'Font Size',
            color: 'Color',
            generateTVChannel: 'Generate TV-channel',
            delete: 'Delete info channel',
            sec: ' sec',
            addMedia: 'Add media',
            clearContent: 'Clear content',
            fileFormat: 'Choose files from',
            computer: 'Computer',
            fileManager: 'File manager',
            totalDuration: 'Total duration:',
            imageFormat: 'Image format:',
            chooseResolutionAndAddFile: 'Choose resolution and add files',
            chooseImageResolution: 'Choose image resolution',
            imageResolution: 'Image resolution',
            imageResolutionContent: 'This is image resolution',
            specialLocation: 'This is special location',
            noPreScaling: 'No pre-scaling',
            pivotEnable: 'PIVOT ENABLE',
            play: 'Play:',
            date: 'Date ',
            dateEdit: 'Date:',
            time: 'Time:',
            defaultImageTime: 'Default Image Time:',
            sound: 'Sound:',
            copySchedule: 'Copy schedule',
            playInfoChannel: 'Play info channel',
            deleteSchedule: 'Delete schedule',
            disableInteraction: 'DISABLE INTERACTION'
        },
        cluster: {
            noPermission: 'No permission to read cluster settings'
        },
        settings: {
            categoryOption: {
                clientChannel: 'Client :: Channel',
                generalInfoChannels: 'General :: Info Channels',
                generalLanguagesAndLocales: 'General :: Languages and Locales',
                services: 'Services :: Services',
                supportEmail: 'Support :: Email',
                support: 'Support :: Support'
            },
            category: 'Category',
            saveSuccess: 'Settings saved successfully',
            title: 'Settings',
            searchCategory: 'Search Category',
            channelNumberInputTimeout: 'Channel Number Input Timeout (milliseconds)',
            Multicast: 'Multicast IP Ranges',
            retryOnChannelPlaybackError: 'RETRY ON CHANNEL PLAYBACK ERROR',
            useChannelCategories: 'USE CHANNEL CATEGORIES',
            audioLanguage1: 'Audio Language 1st',
            audioLanguage2: 'Audio Language 2nd',
            DLXStartupMode: 'DLX Startup Mode',
            searchLanguage1: 'Search Language 1st',
            searchLanguage2: 'Search Language 2nd',
            searchDLXStartupMode: 'Search DLX Startup Mode',
            DLXEseStartupModeOnResume: 'DLX USE STARTUP MODE ON RESUME',
            inactivityTimeout: 'Inactivity Timeout (minutes)',
            inactivityTimeoutAction: 'Inactivity Timeout Action',
            searchInactivityTimeoutAction: 'Search Inactivity Timeout Action',
            infoPage: 'Info Page ',
            searchInfoPage: 'Search Info Page ',
            initialVolume: 'Initial Volume (%)',
            searchInitialVolume: 'Search Initial Volume',
            menuButtonAlwaysGoesToMainMenu: ' MENU BUTTON ALWAYS GOES TO MAIN MENU',
            subtitleLanguage1: 'Subtitle Language 1st',
            subtitleLanguage2: 'Subtitle Language 2nd',
            defaultChannelGroup: 'Default Channel Group',
            searchDefaultChannelList: 'Search Default Channel Group',
            subtitlesEnabled: 'SUBTITLES ENABLED',
            useSessionBookmarks: 'USE SESSION BOOKMARKS',
            defaultLockCode: 'Default Lock Code',
            defaultPinCode: 'Default Pin Code',
            infoChannelMaxUploadSize: 'Info Channel Max Upload Size',
            searchInfoChannelMaxUploadSize: 'Search Max Upload Size',
            defaultSystemLanguage: 'Default System Language',
            searchDefaultSystemLanguage: 'Search Default System Language',
            browserHomepage: 'Browser Homepage',
            supportMessage: 'Support Message E-Mail',
            errorAlertLimit: 'Error Alert Limit',
            maxDelayOnUpgrade: 'Client Operation Max Delay On Upgrade',
            minDelayOnUpgrade: 'Client Operation Min Delay On Upgrade',
            onUpgrade: 'Client Operation Delay On Upgrade',
            emailEncoding: 'Email Encoding',
            emailPassword: 'Email Password',
            emailPort: 'Email Port',
            emailReply: 'Email Reply',
            emailServer: 'Email Server',
            emailUsername: 'Email Username',
            emailSmtpTimeout: 'Email Smtp Timeout',
            emailUsetls: 'Email Usetls',
            maxTriggeredRequests: 'Max Triggered Requests Per Second',
            contentNumberInputTimeout: 'The timeout before selecting the entered channel when inputting channel numbers',
            contentMulticast: 'Clients with an IP in these ranges will be eligible for multicast playback',
            contentInactivityTimeout: 'When this long has passed without any key presses an inactivity timeout is triggered in the portal, which can put the device in standby or perform other actions depending on the Inactivity Timeout Action setting. Can be set to a negative value to disable inactivity timeouts.',
            saveSuccess: 'Settings saved successfully',
            timeZone: 'Time Zone',
            searchTimeZone: 'Search Time Zone',
        },
        calendar: {
            addNewEvent: 'Add new event'
        },
        externalDevice: {
            list: 'External Device',
            clientID: 'Client ID',
            back: 'Back to external device',
            edit: 'Editing external device',
            add: 'Add external device',
            titleConfirm: 'Delete external device',
            confirmDelete: 'Do you want to delete the selected external device?',
            listDevices: 'Devices List'
        },
        room: {
            error: {
                noExist: 'Room does not exist',
            }
        }
    },
    resources: {
        infoPage: {
            infoPageName: 'Info Page:',
            infoPage: 'Info Page',
            rename_info_page: 'Rename Info Page',
            create_title: 'Create Info Page',
            clone_title: 'Clone Info Page',
            template_info_page: 'Template info page',
            search_template_info_page: 'Search template info Page',
            filter_info_page: 'Filter info page',
            btnPreview: 'Preview active info page ',
            nodeType: 'Node type',
            infoPageType: 'Info Page Type',
            Preview: 'Preview',
            special_attr: 'Special Attributes',
            heading: 'Common attributes',
            choose: 'Choose a color to preview',
            addContent: 'Add content page',
            editContent: 'Edit content page',
            copyOrAddLanguage: 'Copy/add language',
            addSubentry: 'Add subentry',
            active: 'ACTIVE',
            weather: 'Weather',
            filter_location: 'Search city',
            filter_infoPageType: 'Filter info page type',
            filter_function: 'Filter function',
            filter_input_device: 'Filter input device',
            filter_availableApp: 'Filter available app',
            filter_cast_device_input: 'Filter cast device input',
            filter_wifi_encryption_type: 'Filter wifi encryption type',
            filter_select_info_page: 'Filter info page',
            filter_select_language: 'Filter language',
            filter_select_tv_menu: 'Filter tv menu',
            createNew: 'Create New',
            clone: 'Clone',
            function: 'Function',
            tv_mode: 'TV mode',
            generic_media: 'Play generic media item',
            radio: 'Radio',
            service_call: 'Service Call',
            slide_show: 'Slideshow',
            remote_site_launcher: 'Remote site launcher',
            rss: 'RSS',
            launch_tv_app: 'Launch TV-app',
            launch_tv_app_data: 'Launch TV-app data',
            launch_tv_app_content: 'This is launch TV-app data',
            play_movie: 'Play movie',
            start_inactive_browser: 'Start inactive browser',
            generic_qr_caster: 'Generic QR Caster',
            media_grid: 'Media grid (A/V)',
            launch_usb: 'Launch USB',
            sleeper_timer: 'Sleep timer',
            stop_watch: 'Stop watch',
            wake_up_call: 'Wake up call',
            external_services: 'External services',
            treeMain: 'Main',
            doesNotAssign: 'This Info Page is not be assigned to any cluster',
            publishSuccess: 'Info Page has been published successfully',
            date_time: 'Date/time',
            icon_text_size: 'Icon text size',
            background_image: 'Background image',
            logotype: 'Logotype',
            instructional_video: 'Instructional video',
            featured_image: 'Featured image',
            child_lock: 'Child lock',
            save: 'Save',
            override: "Override",
            keep_working: "Keep working",
            new_version_title: "New version is available",
            new_version_content: 'Do you want to keep working on your version? All your works will be deleted if you press "Override".',
            info_page_rename_label: "Info page rename",
            info_page_rename_content: "This is info page rename content",
            create_or_clone_label: "Info page create/clone",
            create_or_clone_content: "This is info page create/clone content",
            info_page_name_placeholder: 'Info page name',
            get_latest_version: 'Get latest version',
            contentBackgroundImage: 'This is background image',
            contentLogoType: 'This is logo type',
            contentVideo: 'This is video ',
            contentFeaturedImage: 'This is featured image',
            // get_latest_version_title: 'Get latest version?',
            get_latest_version_content: 'All your works will be deleted if you press "OKAY".',
            delete_info_page_title: 'Delete Info Page?',
            delete_info_page_success: 'Info Page deleted successfully',
            publish_info_page_title: 'Publish Info Page?',
            publish_info_page_success: 'Are you sure you want to publish these info pages?',
            cancel_changes: 'Cancel changes',
            confirm_cancel_changes: 'Are you sure you want to cancel all changes?',
            confirm_preview_title: 'Info Page will be saved to preview',
            confirm_preview_subtitle: 'Are you sure to want to do that?',
            saveInfoPage: 'Great job! You have saved $1 info page',
            pin_code_placeholder: 'Pin code',
            enableLogout: 'Enable Logout',
            disableLogout: 'Disable Logout',
            enableArchiveImages: 'Enable Archive Images',
            disableArchiveImages: 'Disable Archive Images',
            enableArchiveVideos: 'Enable Archive Videos',
            disableArchiveVideos: 'Disable Archive Videos',
            enableAudioIN: "Enable Audio IN",
            disableAudioIN: "Disable Audio IN",
            enableAudioOUT: "Enable Audio OUT",
            disableAudioOUT: "Disable Audio OUT",
            serviceCall: {
                ipAddress: 'IP-address',
                ipAddressLabel: 'Service IP-Address',
                ipAddressContent: 'This is service IP-Address',
            },
            weatherObj: {
                location: 'Location',
                locationLabel: 'Weather location',
                locationContent: 'This is weather location',
            },
            slideShow: {
                infoChannelId: 'Info channel ID',
                infoChannelIdLabel: 'Slideshow Info Channel ID',
                infoChannelIdContent: 'This is info channel id for slideshow',
            },
            launchTVApp: {
                availableApp: 'Available Apps',
            },
            genericQRCaster: {
                cast_paring_url: 'Cast Pairing URL',
                cast_paring_url_content: 'This is cast pairing URL',
                wifi_ssid: 'Wifi SSID',
                wifi_ssid_content: 'This is Wifi SSID',
                cast_device_name: 'Cast Device Name',
                cast_device_name_content: 'This is cast device name',
                wifi_password: 'Wifi Password',
                wifi_password_content: 'This is wifi password',
                wifi_encryption_type: 'Wifi Encryption Type',
                wifi_encryption_type_content: 'This is wifi encryption',
                cast_device_input: 'Cast Device Input',
                cast_device_input_content: 'This is cast device input',
            },
            genericMedia: {
                usb_power_control: 'USB POWER CONTROL',
                info_message: 'INFO MESSAGE',
                title: 'Title',
                title_label: 'This is generic media title',
                select_input_device: 'Select Input Device',
                hdmi_1: 'HDMI 1',
                hdmi_2: 'HDMI 2',
                hdmi_3: 'HDMI 3',
                usb: 'USB',
                info_channel: 'Info Channel',
                media_file: 'Media file from file manager',
                channel_id: 'Channel ID',
                usbPath: 'Path'
            },
            radioItem: {
                enable_categories: 'Enable categories',
                screen_saver_timeout: 'Screen saver timeout'
            },
            playMovie: {
                movie: 'Movie'
            },
            startInactiveBrowser: {
                enable_metadata: 'Enable Metadata'
            },
            linked_menu: {
                select_info_page: 'Select an info page',
                select_language: 'Select a language',
                select_tv_menu: 'Select a tv menu'
            },
            rss_application: {
                url: 'URL',
                url_content: 'This is RSS url',
                updateFrequency: 'Update Frequency',
                updateFrequency_content: 'This is rss update frequency'
            }
        },
        role: {
            title: 'Role management',
            createrole: 'CREATE NEW ROLE',
            edit: 'edit',
            back: 'Back to Role Managament',
            message: "Great job!",
            save: 'save!',
            success: "Create Role success",
            rolenamecharacter: 'Input role name < 50 characters',
            nodata: 'No data found',
            rolename: 'Role name',
            roleName: 'Role Name',
            read: 'Read',
            edit: 'Edit',
            expandall: 'EXPAND ALL',
            Save: 'Save',
            save: 'Save',
            TitleUnsave: 'You have unsaved changes',
            ConstTentUnsave: 'Do you want to save them before leaving?',
            contentUnsave: 'Do you want to save them before leaving?',
            ConstentRole: 'This is role name',
            constentRole: 'This is role name',
            messageRole: 'Great job! $1 saved!',
            createRole: 'Create Role',
            delete: 'Delete role',
            confirmDelete: 'Do you want to delete the selected role?',
            affectedUser: 'This will likely affect users with this role.',
            pleaseAssign: 'Please choose a different role to assign for affected users',
            deleted: 'Delete role $1 success',
            placeholder: 'Filter role name',
            error: {
                exist: 'Role name is already exist'
            }
        },
        severlog: {
            select: 'select',
            Time: 'Time',
            Level: 'Level',
            Message: 'Message',
            error: 'Error',
            debug: 'Debug',
            info: 'Info',
            warn: 'Warn',
            silent: 'Silent',
            verbose: 'Verbose',
            silly: 'Silly',
            all: 'All',
            severlog: 'Server Log',
            datestartstop: 'Date and time for server log',
            nodata: 'No data match your search criteria!',
            loglevel: "Log level",
            title: 'Calendar',
            content: 'This is calendar picker'

        }
        ,
        group: {
            cluster: 'Cluster',
            clusters: 'Clusters',
            search: 'Search group',
            rooms: 'Rooms',
            room: 'Room',
            tv: 'TV',
            tvs: `TV'S`,
            addCluster: 'Add new Cluster',
            back: 'Back to Region Stockholm',
            title: 'Danderyds sjukhus'
        },
        room: {
            assignRelative: 'Assign relative',
            editRoom: 'Edit room',
            noPermission: 'No permission to read room list',
            metedata: 'Add meta data',
            titlelocation: 'Room location',
            contentlocation: 'This is room location',
            editFailed: 'Edit failed',
            saveSuccess: 'Save success',
            saveFailed: 'Save failed',
            deleteFailed: 'Delete failed',
            deleteCluster: 'Delete cluster',
            deleteRoom: 'Delete room',
            sendMessage: 'Send message',
            sendAlarm: 'Send Alarm',
            relative: 'Relative(s)',
            search: 'Search room',
            cluster: 'Cluster',
            clusters: 'Clusters',
            updating: 'Updating',
            editRoom: 'Edit room',
            externalDevice: 'External device(s)',
            externalService: 'External service(s)',
            calendar: 'Calendar',
            general: 'General',
            settings: 'Settings',
            channelLists: 'Channel lists',
            unit: 'Unit',
            close: 'Close',
            addMetaData: 'Add meta data',
            [`device(s)`]: 'Device(s)',
            settings: 'Settings',
            infoChannels: 'Info channels',
            deviceFirmwareUpdate: 'Device firmware update',
            language: 'Language',
            onGoing: 'Ongoing',
            addRoom: 'Add room',
            roomLocation: 'Room location',
            roomNumber: 'Room ID',
            dateStartStop: 'Start and stop date for the room(s)',
            roomName: 'Room Name (Care taker)',
            specialLocation: 'Special location',
            parentalControl: 'Parental control',
            controlCode: 'Control code',
            payTV: 'Pay Tv',
            rooms: 'Rooms',
            room: 'Room',
            tv: 'TV',
            tvs: `TV'S`,
            vod: 'VOD',
            offline: 'Offline',
            edit: 'Edit',
            save: 'Save',
            start: 'Start',
            stop: 'Stop',
            cancel: 'Cancel',
            menu: 'Menu',
            noEndDate: 'No end date',
            ok: 'Ok',
            add: 'Add',
            inSameGroup: 'In same group',
            editCluster: 'Edit cluster',
            expandAll: 'Expand all wards',
            showRoomId: 'Show room id',
            addNewRoom: 'Add new room',
            infoChannel: 'Info channel',
            devices: 'Devices',
            send: 'Send',
            addCluster: 'Add new Cluster',
            back: 'Back to Region Stockholm',
            title: 'Danderyds sjukhus',
            from: 'From',
            to: 'To',
            settimeto: ' Set time to',
            settimefrom: ' Set time from',
            roomNumberTitle: 'Room number',
            roomNumberContent: 'This is room number',
            roomNameContent: 'This is room name',
            bokaMera: 'Bokamera',
        },
        messages: {
            Entity: 'ENTITY',
            Group: 'GROUP',
            Cluster: 'CLUSTER',
            Room: 'ROOM',
            User: 'USER',
            sendmessage: 'Send message',
            editDraftMessage: 'Edit draft message',
            editScheduleMessage: 'Edit schedule message',
            sendNewMessage: 'Send new message',
            sendMessageCluster: 'Send Message',
            addrecipients: 'Add recipients',
            addallrecipients: 'ADD ALL ',
            selectrecipients: 'Select recipients',
            empty: 'Empty',
            priority: 'Priority',
            prioritymessage: 'This is message priority',
            messagetype: 'Message type',
            critical: 'Critical',
            Normal: "Normal",
            popup: "Pop-up",
            Notification: "Notification banner",
            Schedule: 'Schedule',
            Immediately: "Immediately",
            OneTime: "One Time",
            Other: "Other",
            Repeatly: 'Repeatly',
            ScheduleTemplate: "Schedule Template",
            Dateandtime: 'Date and time for scheduling message',
            user: 'User',
            inbox: 'INBOX',
            sentSuccess: 'Your message has been sent successfully',
            scheduleSuccess: 'Your message has been scheduled successfully',
            draftSuccess: 'Your message has been draft successfully',
            searchMessage: 'Search messages',
            none: "None",
            daytime: "Day/time",
            expireDateTimeText: "Date and time for message expire",
            searchTemplates: 'Search templates',
            searchScheduler: 'Search scheduler',
            createTemplate: 'Create template',
            editTemplate: 'Edit template',
            createSchedule: 'Create New Scheduled Template',
            editSchedule: 'Edit New Scheduled Template',
            addMessage: "Add New Message",
            editMessage: "Edit New Message",
            message: 'Messages',
            sendMessageTo: 'Send message to:',
            editDraft: 'Edit Draft',
            editSchedule: 'Edit Schedule',
            sent: 'Sent',
            from: 'From',
            to: 'To',
            subject: 'Subject',
            Message: 'Message',
            createMessage: 'Create new message',
            created: 'Created',
            received: 'Received',
        },
        messageAlarm: {
            messageAlarmTitle: 'Alarm Clock',
            messageAlarmContent: 'This is a Message Alarm Clock picker',
            messageAlarmDateTime: 'Date and time for Message Alarm Clock',
            messageAlarmLogLevel: 'Alarm Type',
            messageAlarmListDevices: 'List Devices',
            messageAlarmTime: 'Time',
            messageAlarmEvent: 'Event',
            messageAlarmMessage: 'Message',
            connect: 'Connect',
            keepalive: 'Keep Alive',
            lost: 'Lost',
            report: 'Report',
            detect: 'Detect',
            search: 'Search',
        },
        alarm: {
            alarm: 'Alarms',
            sendalarm: 'Send alarm',
            createCalendar: 'Create Calendar',
            sendNewAlarm: 'Send new alarm',
            sent: 'SENT',
            draft: 'DRAFT',
            schedule: 'SCHEDULED',
            of: 'of',
            refresh: 'Refresh',
            sendAlarmCluster: 'Send Alarm',
            Dateandtime: 'Date and time for scheduling alarm',
            DateandtimeCalendar: 'Date and time for scheduling calendar',
            entity: 'Entity',
            group: 'Group',
            cluster: 'Cluster',
            individuals: 'Individuals',
            searchAlarm: 'Search alarm',
            search: 'Search ',
            sentSuccess: 'Your alarm has been sent successfully',
            scheduleSuccess: 'Your alarm has been scheduled successfully',
            draftSuccess: 'Your alarm has been draft successfully',
            editAlarm: "Edit alarm",
            editDraftAlarm: 'Edit draft alarm',
            editScheduleAlarm: 'Edit schedule alarm',
            addsound: 'Add new sound',
            browsefile: 'Browse file manager',
            Nodata: 'No recipients selected',
            editDraft: 'Edit Draft',
            editSchedule: 'Edit Schedule',
        },
        customers: {
            name: 'Customer |||| Customers',
            fields: {
                commands: 'Orders',
                first_seen: 'First seen',
                groups: 'Segments',
                last_seen: 'Last seen',
                last_seen_gte: 'Visited Since',
                name: 'Name',
                total_spent: 'Total spent',
                password: 'Password',
                confirm_password: 'Confirm password',
            },
            fieldGroups: {
                identity: 'Identity',
                address: 'Address',
                stats: 'Stats',
                history: 'History',
                password: 'Password',
                change_password: 'Change Password',
            },
            page: {
                delete: 'Delete Customer',
            },
            errors: {
                password_mismatch:
                    'The password confirmation is not the same as the password.',
            },
        },
        commands: {
            name: 'Order |||| Orders',
            amount: '1 order |||| %{smart_count} orders',
            title: 'Order %{reference}',
            fields: {
                basket: {
                    delivery: 'Delivery',
                    reference: 'Reference',
                    quantity: 'Quantity',
                    sum: 'Sum',
                    tax_rate: 'Tax Rate',
                    total: 'Total',
                    unit_price: 'Unit Price',
                },
                customer_id: 'Customer',
                date_gte: 'Passed Since',
                date_lte: 'Passed Before',
                total_gte: 'Min amount',
                status: 'Status',
                returned: 'Returned',
            },
        },
        invoices: {
            name: 'Invoice |||| Invoices',
            fields: {
                date: 'Invoice date',
                customer_id: 'Customer',
                command_id: 'Order',
                date_gte: 'Passed Since',
                date_lte: 'Passed Before',
                total_gte: 'Min amount',
                address: 'Address',
            },
        },
        products: {
            name: 'Poster |||| Posters',
            fields: {
                category_id: 'Category',
                height_gte: 'Min height',
                height_lte: 'Max height',
                height: 'Height',
                image: 'Image',
                price: 'Price',
                reference: 'Reference',
                stock_lte: 'Low Stock',
                stock: 'Stock',
                thumbnail: 'Thumbnail',
                width_gte: 'Min width',
                width_lte: 'Max width',
                width: 'Width',
            },
            tabs: {
                image: 'Image',
                details: 'Details',
                description: 'Description',
                reviews: 'Reviews',
            },
        },
        categories: {
            name: 'Category |||| Categories',
            fields: {
                products: 'Products',
            },
        },
        reviews: {
            name: 'Review |||| Reviews',
            amount: '1 review |||| %{smart_count} reviews',
            relative_to_poster: 'Review on poster',
            detail: 'Review detail',
            fields: {
                customer_id: 'Customer',
                command_id: 'Order',
                product_id: 'Product',
                date_gte: 'Posted since',
                date_lte: 'Posted before',
                date: 'Date',
                comment: 'Comment',
                rating: 'Rating',
            },
            action: {
                accept: 'Accept',
                reject: 'Reject',
            },
            notification: {
                approved_success: 'Review approved',
                approved_error: 'Error: Review not approved',
                rejected_success: 'Review rejected',
                rejected_error: 'Error: Review not rejected',
            },
        },
        segments: {
            name: 'Segments',
            fields: {
                customers: 'Customers',
                name: 'Name',
            },
            data: {
                compulsive: 'Compulsive',
                collector: 'Collector',
                ordered_once: 'Ordered once',
                regular: 'Regular',
                returns: 'Returns',
                reviewer: 'Reviewer',
            },
        }
    },
};
